import React from 'react';
import Docs from '@/components/Documents/docs/Docs';
import { withRouter, connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store'

@withRouter
class ApiDocs extends React.Component {
  constructor() {
    super();
    this.apiId = null;
  }

  componentWillMount() {
    const apiId = this.props.router.currentRoute.params.docs;
    // 加载数据

    if(apiId === this.apiId) {
      return;
    }
    dispatch.docs.fetch({ apiId });
    this.apiId = apiId;
  }

  componentWillUpdate() {
    const apiId = this.props.router.currentRoute.params.docs;
    // 加载数据

    if(apiId === this.apiId) {
      return;
    }
    dispatch.docs.CLEAN_API();
    dispatch.docs.fetch({ apiId });
    this.apiId = apiId;
  }

  render() {
    const { api, inParamsTable, isLogin } = this.props;

    // 检查 login 状态
    if (isLogin === false) {
      this.props.router.push('/signIn');
    }

    return <Docs api={api} inParamsTable={inParamsTable} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const docs = state.docs;
  const user = state.user;
  return {
    isLogin: user.isLogin,
    api: docs.api,
    inParamsTable: docs.inParamsTable
  }
}

export default connect(mapStateToProps)(ApiDocs);
